const mutateSpaceMeta = (space, meta) => {
  return {
    ...space,
    _meta: {
      ...space._meta,
      ...meta
    }
  };
};

export { mutateSpaceMeta };
//# sourceMappingURL=mutateSpaceMeta.js.map
